import { useTranslation } from 'react-i18next'
import { Add } from '@mui/icons-material'
import { Button, Fab, Grid, Tooltip } from '@mui/material'
import { useField, useFormikContext } from 'formik'
import InputField from 'components/atoms/fields/InputField'
import { FaTrashAlt } from 'react-icons/fa'
import { cloneDeep } from 'lodash'

const AddStudentList = ({ fieldProps }) => {
  const { t } = useTranslation()
  const [field] = useField<any[]>(fieldProps.name)
  const { setFieldValue } = useFormikContext() // Manually set field value in Formik state

  const handleAddEntity = () => {
    setFieldValue(fieldProps.name, [
      ...field.value,
      {
        email: '',
        first_name: '',
        last_name: '',
      },
    ])
  }

  const handleRemoveEntity = (index) => {
    const entities = cloneDeep(field.value)
    entities.splice(index, 1)
    setFieldValue(fieldProps.name, entities)
  }

  return (
    <>
      {field?.value?.length > 0 ? (
          field?.value.map((value: any, index: number) => (

           <Grid container spacing={3} key={index}>
                <Grid item xs={12} lg={3} mb={2}>
                    <InputField
                        fieldProps={{
                            label: t('common.email'),
                            name: `${fieldProps.name}[${index}]['email']`,
                            required: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12} lg={4} mb={2}>
                    <InputField
                        fieldProps={{
                            label: t('common.first-name'),
                            name: `${fieldProps.name}[${index}]['first_name']`,
                            required: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12} lg={4} mb={2}>
                    <InputField
                        fieldProps={{
                            label: t('common.last-name'),
                            name: `${fieldProps.name}[${index}]['last_name']`,
                            required: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12} lg={1} mb={2}>
                  <Tooltip title={`${t('common.delete')}`} arrow placement='top'>
                    <Button
                      onClick={() => { 
                        handleRemoveEntity(index) 
                      } }
                      aria-label='delete'
                      size='small'
                      color='error'
                      variant='outlined'
                      sx={{
                        margin: '0',
                        marginLeft: '10px',
                        boxShadow: 'none',
                        padding: '0.5rem 0.1rem',
                        minWidth: '2.5rem !important',
                        maxWidth: '2.5rem !important',
                      }}
                    >
                      <FaTrashAlt style={{ fontSize: '1.2rem' }} />
                    </Button>
                  </Tooltip>
                </Grid>
           </Grid>
          ))
        ) : (
          <></>
        )}

        <div>
          <Tooltip title={`${t('dashboard.add-a-new-student')}`} arrow placement='top'>
            <Fab
              variant='extended'
              aria-label='add'
              size='small'
              onClick={handleAddEntity}
              color='success'
              sx={{ margin: '1rem 0 0.5rem auto', boxShadow: 'none' }}
            >
              <Add style={{ fontSize: '1.8rem' }} /> {t('dashboard.add-a-new-student')}
            </Fab>
          </Tooltip>
          </div>
    </>
  )
}

export default AddStudentList
